import React from "react";
import {Images} from "../../../../core/utilities/images";
import "./ModalCancelButton.scss";

interface IProps {
  callback: () => void
}

const ModalCancelButton = (props: IProps) => {

  return (
    <div
      id="modal-cancel-button"
      onClick={props.callback}
    >
      <img src={Images.x} alt="x"/>
    </div>
  );
}

export default ModalCancelButton;
